import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Container,
  Tooltip,
  Box,
  Grid,
  Typography,
  Link,
} from "@material-ui/core";

import { useTranslation } from "react-i18next";
import TwitterIcon from "@material-ui/icons/Twitter";
import GitHubIcon from "@material-ui/icons/GitHub";
import Logo from "../Logo";
const useStyles = makeStyles((theme) => ({
  copy: {
    backgroundColor: "#000",
    padding: theme.spacing(1),
  },
  footer: {
    backgroundColor: theme.palette.grey[900],
  },
  lia_footer: {
    maxWidth: theme.spacing(3),
    marginLeft: theme.spacing(1),
    display: "inline-block",
  },
  text_footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  footer_ass_link: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  content: {
    padding: "60px 10px",
  },
  ul: {
    color: theme.palette.background.paper,
    paddingInlineStart: theme.spacing(3),
    marginTop: 0,
  },
  icon: {
    padding: theme.spacing(1),
  },
  brand: {
    "&:hover": {
      textDecoration: "none",
    },
  },
}));

const WhiteTextTypography = withStyles({
  root: {
    color: "#FFFFFF",
    display: "block",
  },
})(Typography);

const MutedTextTypography = withStyles({
  root: {
    color: "#888",
    display: "block",
  },
})(Typography);


const openFAQ = function(){
  /*
  let dialog = document.createElement("dialog");
  dialog.id= 'faq_dialog'
  document.body.appendChild(dialog);
  dialog.innerHTML = '<div><div class="MuiPaper-root MuiAccordion-root Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded"><div class="MuiButtonBase-root MuiAccordionSummary-root makeStyles-accordiontitle-7 Mui-expanded" tabindex="0" role="button" aria-disabled="false" aria-expanded="true"><div class="MuiAccordionSummary-content Mui-expanded"><h6 class="MuiTypography-root MuiTypography-subtitle2">How does CASSIE works?</h6></div><div class="MuiButtonBase-root MuiIconButton-root MuiAccordionSummary-expandIcon Mui-expanded MuiIconButton-edgeEnd" aria-disabled="false" aria-hidden="true"><span class="MuiIconButton-label"><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></span><span class="MuiTouchRipple-root"></span></div></div><div class="MuiCollapse-root MuiCollapse-entered" style="min-height: 0px; height: auto; transition-duration: 237ms;"><div class="MuiCollapse-wrapper"><div class="MuiCollapse-wrapperInner"><div role="region"><div class="MuiAccordionDetails-root makeStyles-accordioncontent-8"><p class="MuiTypography-root MuiTypography-body1">CASSIE uses Google Earth Engine (GEE), a platform of parallel processing in geospatial data cloud (<a href="https://www.sciencedirect.com/science/article/pii/S0034425717302900" target="_blank">Gorelick et al., 2017</a>). CASSIE communicates with the GEE through an API (Application Programming Interface), which allows it to use the datasets and processing potential of the GEE.</p></div></div></div></div></div></div><div class="MuiPaper-root MuiAccordion-root Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded"><div class="MuiButtonBase-root MuiAccordionSummary-root makeStyles-accordiontitle-7 Mui-expanded" tabindex="0" role="button" aria-disabled="false" aria-expanded="true"><div class="MuiAccordionSummary-content Mui-expanded"><h6 class="MuiTypography-root MuiTypography-subtitle2">What satellite image datasets are available at CASSIE?</h6></div><div class="MuiButtonBase-root MuiIconButton-root MuiAccordionSummary-expandIcon Mui-expanded MuiIconButton-edgeEnd" aria-disabled="false" aria-hidden="true"><span class="MuiIconButton-label"><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></span><span class="MuiTouchRipple-root"></span></div></div><div class="MuiCollapse-root MuiCollapse-entered" style="min-height: 0px; height: auto; transition-duration: 237ms;"><div class="MuiCollapse-wrapper"><div class="MuiCollapse-wrapperInner"><div role="region"><div class="MuiAccordionDetails-root makeStyles-accordioncontent-8"><p class="MuiTypography-root MuiTypography-body1">Currently, CASSIE enables analysis with data from <a href="https://developers.google.com/earth-engine/datasets/catalog/COPERNICUS_S2" target="_blank">Sentinel 2 (MSI, TOA) Level-1C</a> and the Landsat collections (<a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LT05_C01_T1_SR" target="_blank">Landsat 5 TM SR Tier 1</a>, <a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LE07_C01_T1_SR" target="_blank">Landsat 7 ETM+ SR Tier 1</a>, <a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LC08_C01_T1_SR" target="_blank">Landsat 8 OLI SR Tier 1</a>). When Tier 1 images (higher quality) arent available for Landsat 7 and 8, CASSIE uses images from the <a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LE07_C01_T2_TOA" target="_blank">Landsat 7 TOA Tier 2</a> and <a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LC08_C01_T2_TOA" target="_blank">Landsat 8 TOA Tier 2</a>.</p></div></div></div></div></div></div><div class="MuiPaper-root MuiAccordion-root Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded"><div class="MuiButtonBase-root MuiAccordionSummary-root makeStyles-accordiontitle-7 Mui-expanded" tabindex="0" role="button" aria-disabled="false" aria-expanded="true"><div class="MuiAccordionSummary-content Mui-expanded"><h6 class="MuiTypography-root MuiTypography-subtitle2">How do I access CASSIE?</h6></div><div class="MuiButtonBase-root MuiIconButton-root MuiAccordionSummary-expandIcon Mui-expanded MuiIconButton-edgeEnd" aria-disabled="false" aria-hidden="true"><span class="MuiIconButton-label"><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></span><span class="MuiTouchRipple-root"></span></div></div><div class="MuiCollapse-root MuiCollapse-entered" style="min-height: 0px; height: auto; transition-duration: 222ms;"><div class="MuiCollapse-wrapper"><div class="MuiCollapse-wrapperInner"><div role="region"><div class="MuiAccordionDetails-root makeStyles-accordioncontent-8"><p class="MuiTypography-root MuiTypography-body1">CASSIE is available as an open source tool, available at <a href="http://cassie-stable.herokuapp.com/">this link</a>. The user needs a <a href="https://myaccount.google.com">Google account</a> registered (and approved) on <a href="https://signup.earthengine.google.com">Google Earth Engine plataform</a>. CASSIE code is available at <a href="https://github.com/lia-univali/cassie">GitLab</a></p></div></div></div></div></div></div><div class="MuiPaper-root MuiAccordion-root Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded"><div class="MuiButtonBase-root MuiAccordionSummary-root makeStyles-accordiontitle-7 Mui-expanded" tabindex="0" role="button" aria-disabled="false" aria-expanded="true"><div class="MuiAccordionSummary-content Mui-expanded"><h6 class="MuiTypography-root MuiTypography-subtitle2">When I sign in with my Google Account, the page loads up indefinitely</h6></div><div class="MuiButtonBase-root MuiIconButton-root MuiAccordionSummary-expandIcon Mui-expanded MuiIconButton-edgeEnd" aria-disabled="false" aria-hidden="true"><span class="MuiIconButton-label"><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></span><span class="MuiTouchRipple-root"></span></div></div><div class="MuiCollapse-root MuiCollapse-entered" style="min-height: 0px; height: auto; transition-duration: 237ms;"><div class="MuiCollapse-wrapper"><div class="MuiCollapse-wrapperInner"><div role="region"><div class="MuiAccordionDetails-root makeStyles-accordioncontent-8"><p class="MuiTypography-root MuiTypography-body1">To access and use CASSIE, the user account must be registered on the Google Earth Engine (GEE) platform. The registration can be done through this <a href="https://earthengine.google.com/signup/" target="_blank">link</a>. Once the registration is confirmed, the user can access and sign in to CASSIE with your Google account.</p></div></div></div></div></div></div><div class="MuiPaper-root MuiAccordion-root Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded"><div class="MuiButtonBase-root MuiAccordionSummary-root makeStyles-accordiontitle-7 Mui-expanded" tabindex="0" role="button" aria-disabled="false" aria-expanded="true"><div class="MuiAccordionSummary-content Mui-expanded"><h6 class="MuiTypography-root MuiTypography-subtitle2">My account is registered in Google Earth Engine, but I still cant access the tool</h6></div><div class="MuiButtonBase-root MuiIconButton-root MuiAccordionSummary-expandIcon Mui-expanded MuiIconButton-edgeEnd" aria-disabled="false" aria-hidden="true"><span class="MuiIconButton-label"><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></span><span class="MuiTouchRipple-root"></span></div></div><div class="MuiCollapse-root MuiCollapse-entered" style="min-height: 0px; height: auto; transition-duration: 260ms;"><div class="MuiCollapse-wrapper"><div class="MuiCollapse-wrapperInner"><div role="region"><div class="MuiAccordionDetails-root makeStyles-accordioncontent-8"><p class="MuiTypography-root MuiTypography-body1">Registration on the Google Earth Engine platform is terminated with a confirmation received via email. In some cases, the confirmation email is received instantly after the registration is made. However, confirmation is not always instantaneous and can take time that the CASSIE team has no control over. If the user has made the registration and has not yet received the confirmation email, and considers that the waiting time is too long, the user should contact the <a href="https://developers.google.com/earth-engine/help">Google Earth Engine team</a>. If the user cannot enter even after confirmation, it is recommended to <a href="https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&amp;hl=en" target="_blank">clear the browser cookies.</a></p></div></div></div></div></div></div></div>';
  dialog.innerHTML += "<p>Press ESC to close this window.</p>";
  dialog.showModal();*/
  window.open("https://cassiecore.paginas.ufsc.br/perguntas-frequentes/");
}

const openProblemsDialog = function(){
  let dialog = document.createElement("dialog");
  dialog.id= 'problems_dialog'
  document.body.appendChild(dialog);
  dialog.innerHTML = "<h1>Known Issues</h1>";
  dialog.innerHTML += "<p>CASSIE is still under development, some processes may fail. These are some known issues.</p>";
  dialog.innerHTML += "<p><b>Big Data Analysis</b></p>";
  dialog.innerHTML += "<p>Sometimes CASSIE Can't perform large analyses, with large region or with many images.</p>";
  //dialog.innerHTML +="<div><input type='button' value='Close' onClick='document.getElementById(\"problems_dialog\").close()' /></div>";
  dialog.innerHTML += "<p>Press ESC to close this window.</p>";
  
  dialog.showModal();
}

export default function Footer(managers, techs) {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <Box className={classes.footer}>
      <Container
        className={classes.content}
        maxWidth="md"
        display="flex"
        flexdirection="column"
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} md={3}>
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12}>
                <Link color="inherit" href="/">
                  <WhiteTextTypography variant="h6" className={classes.brand}>
                    <Logo variant="big"/>
                    {t("self.title")}
                  </WhiteTextTypography>
                </Link>
              </Grid>
              <Grid item xs={12}></Grid>
              <Grid item xs={12}>
                <MutedTextTypography variant="subtitle2">
                  {t("home.footer.social")}
                </MutedTextTypography>
                <Link
                  href="https://twitter.com/cassiengine"
                  className={classes.icon}
                >
                  <Tooltip title="Twitter">
                    <TwitterIcon color="secondary" />
                  </Tooltip>
                </Link>
                <Link
                  href="https://codigos.ufsc.br/loc/cassie/"
                  className={classes.icon}
                >
                  <Tooltip title="GitLab">
                    <GitHubIcon color="secondary" />
                  </Tooltip>
                </Link>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Typography variant="h6" color="primary">
                  {t("home.footer.help.title")}
                </Typography>
                <WhiteTextTypography variant="overline">
                  <Link color="inherit"  href="https://github.com/lia-univali/cassie/discussions" target="_blank">
                    {t("home.footer.help.discussion")}
                  </Link>
                </WhiteTextTypography>
                <WhiteTextTypography variant="overline">
                  <Link color="inherit" onClick={openFAQ}>
                    {t("home.footer.help.faq")}
                  </Link>
                </WhiteTextTypography>
                <WhiteTextTypography variant="overline">
                  <Link color="inherit" onClick={openProblemsDialog}>
                    {t("home.footer.help.problems")}
                  </Link>
                </WhiteTextTypography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="h6" color="primary">
                  {t("home.footer.contact.title")}
                </Typography>
                <WhiteTextTypography variant="overline">
                  <Link
                    color="inherit"
                    href={"mailto:cassieengine.core@gmail.com"}
                  >
                    {t("home.footer.contact.techquest")}
                  </Link>
                </WhiteTextTypography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h6" color="primary">
                  {t("home.footer.resources.title")}
                </Typography>
                <WhiteTextTypography variant="overline">
                  <Link
                    target="_blank"
                    rel="noopener"
                    color="inherit"
                    href="https://codigos.ufsc.br/loc/cassie"
                  >
                    {t("home.footer.resources.code")}
                  </Link>
                </WhiteTextTypography>
                <WhiteTextTypography variant="overline">
                  <Link
                    target="_blank"
                    rel="noopener"
                    color="inherit"
                    href="https://codigos.ufsc.br/loc/cassie/-/blob/develop/LICENSE"
                  >
                    {t("home.footer.resources.license")}
                  </Link>
                </WhiteTextTypography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Grid container justifyContent="center" className={classes.copy}>
        <Grid item xs={12} md={12} align="center">
          <WhiteTextTypography component="div">
            <Typography variant="subtitle1" component="span" style={{ fontWeight: 700 }}>
              {t("home.footer.help.termsOfUse")}
            </Typography>
            <Typography variant="body2" component="p">
              {t("home.footer.help.termsOfUseText")}
            </Typography>
          </WhiteTextTypography>

        </Grid>
      </Grid>
    </Box>
  );
}
